/**
 * Returns a list of roots following the binyan pu'al.
 *
 * @returns {string[]} Hebrew roots following the binyan pu'al.
 */
export default function() {
	return [
		"אכל",
		"דבר",
		"עבר",
		"שלח",
		"בקש",
		"ברך",
		"חזק",
		"חטא",
		"כתב",
		"נצל",
		"עבר",
		"פקד",
		"רום",
		"שמר",
		"אבד",
		"אמן",
		"בטח",
		"גדל",
		"הלל",
		"חלל",
		"חשב",
		"טמא",
		"יתר",
		"כבד",
		"כסה",
		"כפר",
		"לחם",
		"לכד",
		"נבא",
		"נגע",
		"סבב",
		"ספר",
		"קבץ",
		"קדש",
		"קרב",
		"שמח",
		"שבר",
		"שכן",
		"שלם",
		"שרת",
		"בער",
		"בקע",
		"ברא",
		"חלק",
		"חנן",
		"טהר",
		"כבס",
		"למד",
		"מרר",
		"מהר",
		"מלט",
		"נכר",
		"נצח",
		"פלל",
		"פרש",
		"צפה",
		"קלל",
		"רחם",
		"רחק",
		"רנן",
		"רפא",
		"שמר",
		"בדל",
		"בצר",
		"בשל",
		"גרש",
		"דמם",
		"זמר",
		"חבר",
		"מאן",
		"נשק",
		"נתץ",
		"נתק",
		"ספר",
		"ערב",
		"פשט",
		"צרף",
		"קדם",
		"קנא",
		"קצר",
		"קשר",
		"רגל",
		"שחק",
		"בצע",
		"ברר",
		"בשר",
		"גדר",
		"גלל",
		"דכא",
		"דשן",
		"חבל",
		"חבק",
		"חמם",
		"חפש",
		"חשק",
		"כהן",
		"כזב",
		"כנס",
		"מסס",
		"מעט",
		"מרר",
		"נגן",
		"נדב",
		"נהל",
		"נחש",
		"נער",
		"נפח",
		"נפץ",
		"נשך",
		"סכך",
		"סכן",
		"סקל",
		"עלל",
		"ענג",
		"עצב",
		"פאר",
		"פזר",
		"פצה",
		"פקח",
		"פרק",
		"פתה",
		"קבל",
		"קדד",
		"קצץ",
		"רמה",
		"רצץ",
		"רקע",
		"שבח",
		"שבר",
		"שנה",
		"שקר",
		"שקף",
		"תכן",
		"תעב",
		"ברכ‎",
		"נשכ‎",
		"סככ‎",
		"אמנ",
		"שכנ",
		"חננ",
		"רננ",
		"מאנ",
		"דשנ",
		"כהנ",
		"נגנ",
		"סכנ",
		"תכנ",
		"רומ",
		"לחמ",
		"שלמ",
		"רחמ",
		"דממ",
		"קדמ",
		"חממ",
		"צרפ",
		"שקפ",
		"קבצ",
		"נתצ",
		"קצצ",
		"רצצ",
		"נפצ",
	];
}
